<template>
  <q-page class="flex column" v-if="reportData">
      <PowerBIReportEmbedded
        :reportId="reportData.reportId"
        :datasetId="reportData.datasetId"
        :groupId="reportData.groupId"
        filterPaneEnabled="false"
        navContentPaneEnabled="false"
      />
  </q-page>
</template>

<script>
import PowerBIReportEmbedded from "@/components/PowerBIReportEmbedded.vue";
export default {
  name: "TradingOverview",
  components: {
    PowerBIReportEmbedded,
  },
  props: ["reportData"],
};
</script>
